import { CustomerAuthLevel, CustomerInfo } from '../../models/Customer';
import { RootState } from '../store';

export const selectIsAuthed = (state: RootState): boolean => {
  return state.customer.data?.isAuthenticated ?? false;
};

export const selectKnownToken = (state: RootState): string | null => {
  return state.customer.data?.knownToken ?? null;
};

export const selectIsCustomerLoaded = (state: RootState): boolean => {
  const { loading, data } = state.customer || {};
  return !!data && !loading;
};

export const selectCustomerInfo = (state: RootState): CustomerInfo | null => {
  return state.customer?.data?.info ?? null;
};

export const selectAuthLevel = (state: RootState): CustomerAuthLevel => {
  const customerData = state.customer.data;
  if (!customerData) return CustomerAuthLevel.ANONYMOUS;
  if (customerData.knownToken) return CustomerAuthLevel.KNOWN;
  if (customerData.isAuthenticated) return CustomerAuthLevel.AUTHENTICATED;
  return CustomerAuthLevel.ANONYMOUS;
};
